module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZEYhN6/tc-custom/9781611520965.jpg?1723407552113",
      "alt": "This image is the cover for the book Devil of a Night"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Devil of a Night\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Steve's relationship with his lover, Carlos, has been on the rocks lately. For months now, they've been distant to each other, quick to argue, and Steven isn't quite sure what's come between them. A night spent clubbing together seemed just the ticket to patch things up and, sure enough, the first half of their evening went well."), _c('br'), _c('br'), _vm._v("But after leaving the club, Carlos must have taken a wrong turn somewhere because the two find themselves lost in the back roads of New Jersey, what's known as the Pine Barrens. Half-joking, Carlos tells Steven a local legend about a mysterious creature called the Jersey Devil."), _c('br'), _c('br'), _vm._v("Then they're run off the road by ... "), _c('i', [_vm._v("something,")]), _vm._v(" Steven can't say what. He feels it out there in the woods watching them. Waiting ...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J.M. Snyder\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0